import {
	COMPLIMENTARY_REASON,
	getComplimentaryReason
} from './complimentaryProducts'

const sameId = (left, right) => String(left) === String(right)

const lineRequirements = (item) => {
	if (item.product_type === 'bundle') {
		const requirements = new Map()
		const add = (variantId, quantity) =>
			requirements.set(variantId, (requirements.get(variantId) || 0) + quantity)
		add(item.product_variant_one_strapi_id, Number(item.product_one_anzahl || 1))
		add(item.product_variant_two_strapi_id, Number(item.product_two_anzahl || 1))
		return requirements
	}
	return new Map([[item.product_variant_strapi_id, 1]])
}

const lineName = (item) =>
	item.product_type === 'bundle'
		? item.product_name
		: `${item.product_name}${item.product_variant ? ` (${item.product_variant})` : ''}`

export const reconcileStockAvailability = (cart, shortages) => {
	const availableByVariant = new Map(
		(shortages || []).map(({ variantId, availableQuantity }) => [
			String(variantId),
			Math.max(0, Number(availableQuantity || 0))
		])
	)
	if (!availableByVariant.size) return { cart, changes: [] }

	const changes = []
	const adjustedCart = cart.flatMap((item) => {
		const requirements = lineRequirements(item)
		let permittedQuantity = Number(item.product_count || 0)

		for (const [variantId, perItem] of requirements) {
			const key = String(variantId)
			if (!availableByVariant.has(key)) continue
			permittedQuantity = Math.min(
				permittedQuantity,
				Math.floor(availableByVariant.get(key) / perItem)
			)
		}

		for (const [variantId, perItem] of requirements) {
			const key = String(variantId)
			if (availableByVariant.has(key)) {
				availableByVariant.set(
					key,
					availableByVariant.get(key) - permittedQuantity * perItem
				)
			}
		}

		if (permittedQuantity !== item.product_count) {
			changes.push({
				item,
				name: lineName(item),
				previousQuantity: item.product_count,
				quantity: permittedQuantity
			})
		}

		return permittedQuantity > 0
			? [{ ...item, product_count: permittedQuantity }]
			: []
	})

	return { cart: adjustedCart, changes }
}

export const removeIneligibleComplimentaryProducts = (
	cart,
	threshold,
	paymentOption = 'PayPal'
) => {
	const paidSubtotal = cart.reduce(
		(total, item) =>
			item.product_type === 'freeProduct'
				? total
				: total + Number(item.product_variant_price || 0) * Number(item.product_count || 0),
		0
	)
	const thresholdEligible =
		Number(threshold || 0) > 0 && paidSubtotal >= Number(threshold)
	const bankTransferEligible = paymentOption === 'Banküberweisung'
	const removed = cart.filter((item) => {
		if (item.product_type !== 'freeProduct') return false
		const reason = getComplimentaryReason(item)
		return reason === COMPLIMENTARY_REASON.BANK_TRANSFER
			? !bankTransferEligible
			: !thresholdEligible
	})
	return {
		cart: removed.length ? cart.filter((item) => !removed.includes(item)) : cart,
		removed
	}
}

export const sameVariantId = sameId
